export * from './view.actions';
export * from './view.effects';
export * from './view.interfaces';
export * from './view.reducer';
export * from './view.service';
export * from './view.selectors';



// WEBPACK FOOTER //
// ./src/app/logics/view/index.ts